/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaVectorScore from './AqaVectorScore';

/**
 * The AqaScore model module.
 * @module model/AqaScore
 * @version v0
 */
export default class AqaScore {
  /**
   * Constructs a new <code>AqaScore</code>.
   * @alias module:model/AqaScore
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaScore</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaScore} obj Optional instance to populate.
   * @return {module:model/AqaScore} The populated <code>AqaScore</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaScore();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('computed'))
        obj.computed = ApiClient.convertToType(data['computed'], 'Boolean');
      if (data.hasOwnProperty('rag'))
        obj.rag = ApiClient.convertToType(data['rag'], 'String');
      if (data.hasOwnProperty('uniquenessRag'))
        obj.uniquenessRag = ApiClient.convertToType(data['uniquenessRag'], 'String');
      if (data.hasOwnProperty('populationRag'))
        obj.populationRag = ApiClient.convertToType(data['populationRag'], 'String');
      if (data.hasOwnProperty('numberRag'))
        obj.numberRag = ApiClient.convertToType(data['numberRag'], 'String');
      if (data.hasOwnProperty('dateRag'))
        obj.dateRag = ApiClient.convertToType(data['dateRag'], 'String');
      if (data.hasOwnProperty('stringRag'))
        obj.stringRag = ApiClient.convertToType(data['stringRag'], 'String');
      if (data.hasOwnProperty('typeRag'))
        obj.typeRag = ApiClient.convertToType(data['typeRag'], 'String');
      if (data.hasOwnProperty('nativeErrorRag'))
        obj.nativeErrorRag = ApiClient.convertToType(data['nativeErrorRag'], 'String');
      if (data.hasOwnProperty('score'))
        obj.score = ApiClient.convertToType(data['score'], 'Number');
      if (data.hasOwnProperty('uniquenessScore'))
        obj.uniquenessScore = ApiClient.convertToType(data['uniquenessScore'], 'Number');
      if (data.hasOwnProperty('populationScore'))
        obj.populationScore = ApiClient.convertToType(data['populationScore'], 'Number');
      if (data.hasOwnProperty('numberScore'))
        obj.numberScore = ApiClient.convertToType(data['numberScore'], 'Number');
      if (data.hasOwnProperty('dateScore'))
        obj.dateScore = ApiClient.convertToType(data['dateScore'], 'Number');
      if (data.hasOwnProperty('stringScore'))
        obj.stringScore = ApiClient.convertToType(data['stringScore'], 'Number');
      if (data.hasOwnProperty('typeScore'))
        obj.typeScore = ApiClient.convertToType(data['typeScore'], 'Number');
      if (data.hasOwnProperty('nativeErrorScore'))
        obj.nativeErrorScore = ApiClient.convertToType(data['nativeErrorScore'], 'Number');
      if (data.hasOwnProperty('rowScore'))
        obj.rowScore = ApiClient.convertToType(data['rowScore'], 'Number');
      if (data.hasOwnProperty('columnScore'))
        obj.columnScore = ApiClient.convertToType(data['columnScore'], 'Number');
      if (data.hasOwnProperty('tableScore'))
        obj.tableScore = ApiClient.convertToType(data['tableScore'], 'Number');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('numberOfPopulationQualityDefinitions'))
        obj.numberOfPopulationQualityDefinitions = ApiClient.convertToType(data['numberOfPopulationQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessQualityDefinitions'))
        obj.numberOfUniquenessQualityDefinitions = ApiClient.convertToType(data['numberOfUniquenessQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfNumberQualityDefinitions'))
        obj.numberOfNumberQualityDefinitions = ApiClient.convertToType(data['numberOfNumberQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfDateQualityDefinitions'))
        obj.numberOfDateQualityDefinitions = ApiClient.convertToType(data['numberOfDateQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfStringQualityDefinitions'))
        obj.numberOfStringQualityDefinitions = ApiClient.convertToType(data['numberOfStringQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfTypeQualityDefinitions'))
        obj.numberOfTypeQualityDefinitions = ApiClient.convertToType(data['numberOfTypeQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorQualityDefinitions'))
        obj.numberOfNativeErrorQualityDefinitions = ApiClient.convertToType(data['numberOfNativeErrorQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfPopulationReds'))
        obj.numberOfPopulationReds = ApiClient.convertToType(data['numberOfPopulationReds'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessReds'))
        obj.numberOfUniquenessReds = ApiClient.convertToType(data['numberOfUniquenessReds'], 'Number');
      if (data.hasOwnProperty('numberOfNumberReds'))
        obj.numberOfNumberReds = ApiClient.convertToType(data['numberOfNumberReds'], 'Number');
      if (data.hasOwnProperty('numberOfDateReds'))
        obj.numberOfDateReds = ApiClient.convertToType(data['numberOfDateReds'], 'Number');
      if (data.hasOwnProperty('numberOfStringReds'))
        obj.numberOfStringReds = ApiClient.convertToType(data['numberOfStringReds'], 'Number');
      if (data.hasOwnProperty('numberOfTypeReds'))
        obj.numberOfTypeReds = ApiClient.convertToType(data['numberOfTypeReds'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorReds'))
        obj.numberOfNativeErrorReds = ApiClient.convertToType(data['numberOfNativeErrorReds'], 'Number');
      if (data.hasOwnProperty('numberOfPopulationAmbers'))
        obj.numberOfPopulationAmbers = ApiClient.convertToType(data['numberOfPopulationAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessAmbers'))
        obj.numberOfUniquenessAmbers = ApiClient.convertToType(data['numberOfUniquenessAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfNumberAmbers'))
        obj.numberOfNumberAmbers = ApiClient.convertToType(data['numberOfNumberAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDateAmbers'))
        obj.numberOfDateAmbers = ApiClient.convertToType(data['numberOfDateAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfStringAmbers'))
        obj.numberOfStringAmbers = ApiClient.convertToType(data['numberOfStringAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfTypeAmbers'))
        obj.numberOfTypeAmbers = ApiClient.convertToType(data['numberOfTypeAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorAmbers'))
        obj.numberOfNativeErrorAmbers = ApiClient.convertToType(data['numberOfNativeErrorAmbers'], 'Number');
      if (data.hasOwnProperty('totalNumberOfQualityDefinitions'))
        obj.totalNumberOfQualityDefinitions = ApiClient.convertToType(data['totalNumberOfQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('totalNumberOfReds'))
        obj.totalNumberOfReds = ApiClient.convertToType(data['totalNumberOfReds'], 'Number');
      if (data.hasOwnProperty('totalNumberOfAmbers'))
        obj.totalNumberOfAmbers = ApiClient.convertToType(data['totalNumberOfAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscretePopulationReds'))
        obj.numberOfDiscretePopulationReds = ApiClient.convertToType(data['numberOfDiscretePopulationReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscretePopulationAmbers'))
        obj.numberOfDiscretePopulationAmbers = ApiClient.convertToType(data['numberOfDiscretePopulationAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteUniquenessReds'))
        obj.numberOfDiscreteUniquenessReds = ApiClient.convertToType(data['numberOfDiscreteUniquenessReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteUniquenessAmbers'))
        obj.numberOfDiscreteUniquenessAmbers = ApiClient.convertToType(data['numberOfDiscreteUniquenessAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberReds'))
        obj.numberOfDiscreteNumberReds = ApiClient.convertToType(data['numberOfDiscreteNumberReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberAmbers'))
        obj.numberOfDiscreteNumberAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateReds'))
        obj.numberOfDiscreteDateReds = ApiClient.convertToType(data['numberOfDiscreteDateReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateAmbers'))
        obj.numberOfDiscreteDateAmbers = ApiClient.convertToType(data['numberOfDiscreteDateAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringReds'))
        obj.numberOfDiscreteStringReds = ApiClient.convertToType(data['numberOfDiscreteStringReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAmbers'))
        obj.numberOfDiscreteStringAmbers = ApiClient.convertToType(data['numberOfDiscreteStringAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteTypeReds'))
        obj.numberOfDiscreteTypeReds = ApiClient.convertToType(data['numberOfDiscreteTypeReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteTypeAmbers'))
        obj.numberOfDiscreteTypeAmbers = ApiClient.convertToType(data['numberOfDiscreteTypeAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNativeErrorAmbers'))
        obj.numberOfDiscreteNativeErrorAmbers = ApiClient.convertToType(data['numberOfDiscreteNativeErrorAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringFormatAmbers'))
        obj.numberOfDiscreteStringFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteStringFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNativeErrorReds'))
        obj.numberOfDiscreteNativeErrorReds = ApiClient.convertToType(data['numberOfDiscreteNativeErrorReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringFormatReds'))
        obj.numberOfDiscreteStringFormatReds = ApiClient.convertToType(data['numberOfDiscreteStringFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberFormatAmbers'))
        obj.numberOfDiscreteNumberFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberFormatReds'))
        obj.numberOfDiscreteNumberFormatReds = ApiClient.convertToType(data['numberOfDiscreteNumberFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberBoundaryAmbers'))
        obj.numberOfDiscreteNumberBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberBoundaryReds'))
        obj.numberOfDiscreteNumberBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteNumberBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateFormatAmbers'))
        obj.numberOfDiscreteDateFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteDateFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateFormatReds'))
        obj.numberOfDiscreteDateFormatReds = ApiClient.convertToType(data['numberOfDiscreteDateFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateBoundaryAmbers'))
        obj.numberOfDiscreteDateBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteDateBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateBoundaryReds'))
        obj.numberOfDiscreteDateBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteDateBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAllowedAmbers'))
        obj.numberOfDiscreteStringAllowedAmbers = ApiClient.convertToType(data['numberOfDiscreteStringAllowedAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAllowedReds'))
        obj.numberOfDiscreteStringAllowedReds = ApiClient.convertToType(data['numberOfDiscreteStringAllowedReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringBoundaryAmbers'))
        obj.numberOfDiscreteStringBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteStringBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringBoundaryReds'))
        obj.numberOfDiscreteStringBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteStringBoundaryReds'], 'Number');
      if (data.hasOwnProperty('rowRag'))
        obj.rowRag = ApiClient.convertToType(data['rowRag'], 'String');
      if (data.hasOwnProperty('columnRag'))
        obj.columnRag = ApiClient.convertToType(data['columnRag'], 'String');
      if (data.hasOwnProperty('tableRag'))
        obj.tableRag = ApiClient.convertToType(data['tableRag'], 'String');
      if (data.hasOwnProperty('numberOfTableQualityDefinitions'))
        obj.numberOfTableQualityDefinitions = ApiClient.convertToType(data['numberOfTableQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfTableReds'))
        obj.numberOfTableReds = ApiClient.convertToType(data['numberOfTableReds'], 'Number');
      if (data.hasOwnProperty('numberOfTableAmbers'))
        obj.numberOfTableAmbers = ApiClient.convertToType(data['numberOfTableAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfRedTableCells'))
        obj.numberOfRedTableCells = ApiClient.convertToType(data['numberOfRedTableCells'], 'Number');
      if (data.hasOwnProperty('numberOfAmberTableCells'))
        obj.numberOfAmberTableCells = ApiClient.convertToType(data['numberOfAmberTableCells'], 'Number');
      if (data.hasOwnProperty('numberOfGreenTableCells'))
        obj.numberOfGreenTableCells = ApiClient.convertToType(data['numberOfGreenTableCells'], 'Number');
      if (data.hasOwnProperty('columnScores'))
        obj.columnScores = ApiClient.convertToType(data['columnScores'], {'String': AqaVectorScore});
      if (data.hasOwnProperty('rowScores'))
        obj.rowScores = ApiClient.convertToType(data['rowScores'], {'String': AqaVectorScore});
      if (data.hasOwnProperty('numberOfOrthogonalVectorsWithErrors'))
        obj.numberOfOrthogonalVectorsWithErrors = ApiClient.convertToType(data['numberOfOrthogonalVectorsWithErrors'], [[['Number']]]);
      if (data.hasOwnProperty('hasNumberOfOrthogonalVectorsWithErrorsUpdate'))
        obj.hasNumberOfOrthogonalVectorsWithErrorsUpdate = ApiClient.convertToType(data['hasNumberOfOrthogonalVectorsWithErrorsUpdate'], 'Boolean');
      if (data.hasOwnProperty('hasTwosDayExtraVectorColourDiscreteValuesUpdate'))
        obj.hasTwosDayExtraVectorColourDiscreteValuesUpdate = ApiClient.convertToType(data['hasTwosDayExtraVectorColourDiscreteValuesUpdate'], 'Boolean');
      if (data.hasOwnProperty('numberOfRows'))
        obj.numberOfRows = ApiClient.convertToType(data['numberOfRows'], 'Number');
      if (data.hasOwnProperty('numberOfColumns'))
        obj.numberOfColumns = ApiClient.convertToType(data['numberOfColumns'], 'Number');
      if (data.hasOwnProperty('numberOfUnadjustedRows'))
        obj.numberOfUnadjustedRows = ApiClient.convertToType(data['numberOfUnadjustedRows'], 'Number');
      if (data.hasOwnProperty('numberOfUnadjustedColumns'))
        obj.numberOfUnadjustedColumns = ApiClient.convertToType(data['numberOfUnadjustedColumns'], 'Number');
      if (data.hasOwnProperty('nmberOfUnadjustedColumns'))
        obj.nmberOfUnadjustedColumns = ApiClient.convertToType(data['nmberOfUnadjustedColumns'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaScore.prototype.id = undefined;

/**
 * @member {Boolean} computed
 */
AqaScore.prototype.computed = undefined;

/**
 * Allowed values for the <code>rag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.RagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.RagEnum} rag
 */
AqaScore.prototype.rag = undefined;

/**
 * Allowed values for the <code>uniquenessRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.UniquenessRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.UniquenessRagEnum} uniquenessRag
 */
AqaScore.prototype.uniquenessRag = undefined;

/**
 * Allowed values for the <code>populationRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.PopulationRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.PopulationRagEnum} populationRag
 */
AqaScore.prototype.populationRag = undefined;

/**
 * Allowed values for the <code>numberRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.NumberRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.NumberRagEnum} numberRag
 */
AqaScore.prototype.numberRag = undefined;

/**
 * Allowed values for the <code>dateRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.DateRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.DateRagEnum} dateRag
 */
AqaScore.prototype.dateRag = undefined;

/**
 * Allowed values for the <code>stringRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.StringRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.StringRagEnum} stringRag
 */
AqaScore.prototype.stringRag = undefined;

/**
 * Allowed values for the <code>typeRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.TypeRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.TypeRagEnum} typeRag
 */
AqaScore.prototype.typeRag = undefined;

/**
 * Allowed values for the <code>nativeErrorRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.NativeErrorRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.NativeErrorRagEnum} nativeErrorRag
 */
AqaScore.prototype.nativeErrorRag = undefined;

/**
 * @member {Number} score
 */
AqaScore.prototype.score = undefined;

/**
 * @member {Number} uniquenessScore
 */
AqaScore.prototype.uniquenessScore = undefined;

/**
 * @member {Number} populationScore
 */
AqaScore.prototype.populationScore = undefined;

/**
 * @member {Number} numberScore
 */
AqaScore.prototype.numberScore = undefined;

/**
 * @member {Number} dateScore
 */
AqaScore.prototype.dateScore = undefined;

/**
 * @member {Number} stringScore
 */
AqaScore.prototype.stringScore = undefined;

/**
 * @member {Number} typeScore
 */
AqaScore.prototype.typeScore = undefined;

/**
 * @member {Number} nativeErrorScore
 */
AqaScore.prototype.nativeErrorScore = undefined;

/**
 * @member {Number} rowScore
 */
AqaScore.prototype.rowScore = undefined;

/**
 * @member {Number} columnScore
 */
AqaScore.prototype.columnScore = undefined;

/**
 * @member {Number} tableScore
 */
AqaScore.prototype.tableScore = undefined;

/**
 * @member {Number} timestamp
 */
AqaScore.prototype.timestamp = undefined;

/**
 * @member {Number} numberOfPopulationQualityDefinitions
 */
AqaScore.prototype.numberOfPopulationQualityDefinitions = undefined;

/**
 * @member {Number} numberOfUniquenessQualityDefinitions
 */
AqaScore.prototype.numberOfUniquenessQualityDefinitions = undefined;

/**
 * @member {Number} numberOfNumberQualityDefinitions
 */
AqaScore.prototype.numberOfNumberQualityDefinitions = undefined;

/**
 * @member {Number} numberOfDateQualityDefinitions
 */
AqaScore.prototype.numberOfDateQualityDefinitions = undefined;

/**
 * @member {Number} numberOfStringQualityDefinitions
 */
AqaScore.prototype.numberOfStringQualityDefinitions = undefined;

/**
 * @member {Number} numberOfTypeQualityDefinitions
 */
AqaScore.prototype.numberOfTypeQualityDefinitions = undefined;

/**
 * @member {Number} numberOfNativeErrorQualityDefinitions
 */
AqaScore.prototype.numberOfNativeErrorQualityDefinitions = undefined;

/**
 * @member {Number} numberOfPopulationReds
 */
AqaScore.prototype.numberOfPopulationReds = undefined;

/**
 * @member {Number} numberOfUniquenessReds
 */
AqaScore.prototype.numberOfUniquenessReds = undefined;

/**
 * @member {Number} numberOfNumberReds
 */
AqaScore.prototype.numberOfNumberReds = undefined;

/**
 * @member {Number} numberOfDateReds
 */
AqaScore.prototype.numberOfDateReds = undefined;

/**
 * @member {Number} numberOfStringReds
 */
AqaScore.prototype.numberOfStringReds = undefined;

/**
 * @member {Number} numberOfTypeReds
 */
AqaScore.prototype.numberOfTypeReds = undefined;

/**
 * @member {Number} numberOfNativeErrorReds
 */
AqaScore.prototype.numberOfNativeErrorReds = undefined;

/**
 * @member {Number} numberOfPopulationAmbers
 */
AqaScore.prototype.numberOfPopulationAmbers = undefined;

/**
 * @member {Number} numberOfUniquenessAmbers
 */
AqaScore.prototype.numberOfUniquenessAmbers = undefined;

/**
 * @member {Number} numberOfNumberAmbers
 */
AqaScore.prototype.numberOfNumberAmbers = undefined;

/**
 * @member {Number} numberOfDateAmbers
 */
AqaScore.prototype.numberOfDateAmbers = undefined;

/**
 * @member {Number} numberOfStringAmbers
 */
AqaScore.prototype.numberOfStringAmbers = undefined;

/**
 * @member {Number} numberOfTypeAmbers
 */
AqaScore.prototype.numberOfTypeAmbers = undefined;

/**
 * @member {Number} numberOfNativeErrorAmbers
 */
AqaScore.prototype.numberOfNativeErrorAmbers = undefined;

/**
 * @member {Number} totalNumberOfQualityDefinitions
 */
AqaScore.prototype.totalNumberOfQualityDefinitions = undefined;

/**
 * @member {Number} totalNumberOfReds
 */
AqaScore.prototype.totalNumberOfReds = undefined;

/**
 * @member {Number} totalNumberOfAmbers
 */
AqaScore.prototype.totalNumberOfAmbers = undefined;

/**
 * @member {Number} numberOfDiscretePopulationReds
 */
AqaScore.prototype.numberOfDiscretePopulationReds = undefined;

/**
 * @member {Number} numberOfDiscretePopulationAmbers
 */
AqaScore.prototype.numberOfDiscretePopulationAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteUniquenessReds
 */
AqaScore.prototype.numberOfDiscreteUniquenessReds = undefined;

/**
 * @member {Number} numberOfDiscreteUniquenessAmbers
 */
AqaScore.prototype.numberOfDiscreteUniquenessAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberReds
 */
AqaScore.prototype.numberOfDiscreteNumberReds = undefined;

/**
 * @member {Number} numberOfDiscreteNumberAmbers
 */
AqaScore.prototype.numberOfDiscreteNumberAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateReds
 */
AqaScore.prototype.numberOfDiscreteDateReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateAmbers
 */
AqaScore.prototype.numberOfDiscreteDateAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringReds
 */
AqaScore.prototype.numberOfDiscreteStringReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringAmbers
 */
AqaScore.prototype.numberOfDiscreteStringAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteTypeReds
 */
AqaScore.prototype.numberOfDiscreteTypeReds = undefined;

/**
 * @member {Number} numberOfDiscreteTypeAmbers
 */
AqaScore.prototype.numberOfDiscreteTypeAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNativeErrorAmbers
 */
AqaScore.prototype.numberOfDiscreteNativeErrorAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringFormatAmbers
 */
AqaScore.prototype.numberOfDiscreteStringFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNativeErrorReds
 */
AqaScore.prototype.numberOfDiscreteNativeErrorReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringFormatReds
 */
AqaScore.prototype.numberOfDiscreteStringFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteNumberFormatAmbers
 */
AqaScore.prototype.numberOfDiscreteNumberFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberFormatReds
 */
AqaScore.prototype.numberOfDiscreteNumberFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteNumberBoundaryAmbers
 */
AqaScore.prototype.numberOfDiscreteNumberBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberBoundaryReds
 */
AqaScore.prototype.numberOfDiscreteNumberBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateFormatAmbers
 */
AqaScore.prototype.numberOfDiscreteDateFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateFormatReds
 */
AqaScore.prototype.numberOfDiscreteDateFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateBoundaryAmbers
 */
AqaScore.prototype.numberOfDiscreteDateBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateBoundaryReds
 */
AqaScore.prototype.numberOfDiscreteDateBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringAllowedAmbers
 */
AqaScore.prototype.numberOfDiscreteStringAllowedAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringAllowedReds
 */
AqaScore.prototype.numberOfDiscreteStringAllowedReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringBoundaryAmbers
 */
AqaScore.prototype.numberOfDiscreteStringBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringBoundaryReds
 */
AqaScore.prototype.numberOfDiscreteStringBoundaryReds = undefined;

/**
 * Allowed values for the <code>rowRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.RowRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.RowRagEnum} rowRag
 */
AqaScore.prototype.rowRag = undefined;

/**
 * Allowed values for the <code>columnRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.ColumnRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.ColumnRagEnum} columnRag
 */
AqaScore.prototype.columnRag = undefined;

/**
 * Allowed values for the <code>tableRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaScore.TableRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaScore.TableRagEnum} tableRag
 */
AqaScore.prototype.tableRag = undefined;

/**
 * @member {Number} numberOfTableQualityDefinitions
 */
AqaScore.prototype.numberOfTableQualityDefinitions = undefined;

/**
 * @member {Number} numberOfTableReds
 */
AqaScore.prototype.numberOfTableReds = undefined;

/**
 * @member {Number} numberOfTableAmbers
 */
AqaScore.prototype.numberOfTableAmbers = undefined;

/**
 * @member {Number} numberOfRedTableCells
 */
AqaScore.prototype.numberOfRedTableCells = undefined;

/**
 * @member {Number} numberOfAmberTableCells
 */
AqaScore.prototype.numberOfAmberTableCells = undefined;

/**
 * @member {Number} numberOfGreenTableCells
 */
AqaScore.prototype.numberOfGreenTableCells = undefined;

/**
 * @member {Object.<String, module:model/AqaVectorScore>} columnScores
 */
AqaScore.prototype.columnScores = undefined;

/**
 * @member {Object.<String, module:model/AqaVectorScore>} rowScores
 */
AqaScore.prototype.rowScores = undefined;

/**
 * @member {Array.<Array.<Array.<Number>>>} numberOfOrthogonalVectorsWithErrors
 */
AqaScore.prototype.numberOfOrthogonalVectorsWithErrors = undefined;

/**
 * @member {Boolean} hasNumberOfOrthogonalVectorsWithErrorsUpdate
 */
AqaScore.prototype.hasNumberOfOrthogonalVectorsWithErrorsUpdate = undefined;

/**
 * @member {Boolean} hasTwosDayExtraVectorColourDiscreteValuesUpdate
 */
AqaScore.prototype.hasTwosDayExtraVectorColourDiscreteValuesUpdate = undefined;

/**
 * @member {Number} numberOfRows
 */
AqaScore.prototype.numberOfRows = undefined;

/**
 * @member {Number} numberOfColumns
 */
AqaScore.prototype.numberOfColumns = undefined;

/**
 * @member {Number} numberOfUnadjustedRows
 */
AqaScore.prototype.numberOfUnadjustedRows = undefined;

/**
 * @member {Number} numberOfUnadjustedColumns
 */
AqaScore.prototype.numberOfUnadjustedColumns = undefined;

/**
 * @member {Number} nmberOfUnadjustedColumns
 */
AqaScore.prototype.nmberOfUnadjustedColumns = undefined;

